<h1 mat-dialog-title>{{data?.title}}</h1>
<div mat-dialog-content>{{data?.message}}</div>
<div mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close style="float: right;" [color]="data?.btnColor" >{{data?.btnText}}</button>
</div>